"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9996],{

/***/ 72084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TickFill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function TickFill(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 29.25,
        height: props.height || 29.25,
        viewBox: "0 0 29.25 29.25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.625 0A14.625 14.625 0 1029.25 14.625 14.623 14.623 0 0014.625 0zm7.488 10.582l-9.4 9.443h-.008a1.27 1.27 0 01-.816.387 1.231 1.231 0 01-.823-.4l-3.941-3.939a.28.28 0 010-.4l1.256-1.248a.272.272 0 01.394 0l3.122 3.122 8.578-8.641a.278.278 0 01.2-.084.255.255 0 01.2.084l1.23 1.273a.277.277 0 01.008.403z",
            fill: props.color || "#000000"
        })
    }));
}


/***/ }),

/***/ 379062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  background: #eee;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      90deg,\n      transparent,\n      rgba(255, 255, 255, 0.6),\n      transparent\n    );\n    animation: ",
        " 1.5s infinite;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 10px;\n  margin-bottom: 25px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var CardSkeleton = function(param) {
    var _type = param.type, type = _type === void 0 ? "product" : _type, customStyles = param.customStyles;
    if (type === "product") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SkeletonContainer, {
            customStyles: customStyles,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImagePlaceholder, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-mb-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60px",
                            height: "27px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "40px",
                            height: "27px"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "100%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "50%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "90%",
                            height: "14px"
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (CardSkeleton);
var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject());
var ShimmerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ShimmerWrapper",
    componentId: "sc-95c11a38-0"
})(_templateObject1(), shimmer);
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SkeletonContainer",
    componentId: "sc-95c11a38-1"
})(_templateObject2(), function(props) {
    var ref;
    return ((ref = props.customStyles) === null || ref === void 0 ? void 0 : ref.width) || "100%";
});
var ImagePlaceholder = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "ImagePlaceholder",
    componentId: "sc-95c11a38-2"
})(_templateObject3());
var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "Row",
    componentId: "sc-95c11a38-3"
})(_templateObject4(), function(props) {
    return props.width;
}, function(props) {
    return props.height || "20px";
});
var RowGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RowGroup",
    componentId: "sc-95c11a38-4"
})(_templateObject5());


/***/ }),

/***/ 639996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ProductListWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(662946);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(780058);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var utils = __webpack_require__(881241);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Snackbar/Snackbar.tsx
var Snackbar = __webpack_require__(185810);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/utils.ts
var ProductListWrapper_utils = __webpack_require__(202386);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react-virtuoso/dist/index.mjs
var dist = __webpack_require__(826246);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(150361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/components/DesignSystem/Card/CardSkeleton.tsx
var CardSkeleton = __webpack_require__(379062);
// EXTERNAL MODULE: ./src/components/VirtualisedList/utils.ts
var VirtualisedList_utils = __webpack_require__(602641);
;// CONCATENATED MODULE: ./src/components/VirtualisedList/index.tsx










var INCREASE_VIEWPORT_BY = 0;
/**
 * the main idea behind this component is to treat the rows as ->
 * 1. `components` - which will have full width and can be changed to any component like heading.
 * 2. `sliced-flex-cards` - which is a flex row containing product cards.
 */ // eslint-disable-next-line react/display-name
var VirtualisedGridList = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(param, virtualisedGridListReference) {
    var listData = param.listData, renderProductCard = param.renderProductCard, itemsRenderConfig = param.itemsRenderConfig, virtualisationContainerStyle = param.virtualisationContainerStyle, _useWindowScroll = param.useWindowScroll, useWindowScroll = _useWindowScroll === void 0 ? true : _useWindowScroll, defaultItemHeight = param.defaultItemHeight;
    var generateCardRows = /**
       * takes a list of card items and convert then into groups of cards to render in each row.
       * number of items in each row is defined by `itemsRenderConfig.columnCount`,
       */ function generateCardRows(indexedListData, index) {
        var ref;
        var resultantPageData = [];
        var rowData = [];
        while(isItemCardType((ref = indexedListData[index]) === null || ref === void 0 ? void 0 : ref.type)){
            var rowId = "".concat(index);
            for(var rowItems = 0; rowItems < itemsRenderConfig.columnCount; rowItems++){
                if (!indexedListData[index]) {
                    break;
                }
                if (isItemCardType(indexedListData[index].type)) {
                    rowData.push(indexedListData[index]);
                    rowId = "".concat(rowId, "-").concat(indexedListData[index].id);
                    index += 1;
                } else {
                    break;
                }
            }
            resultantPageData.push({
                type: "sliced-flex-cards",
                data: rowData,
                id: rowId
            });
            rowData = [];
        }
        return {
            cardRows: resultantPageData,
            updatedIndex: index
        };
    };
    var virtuosoGridRef = (0,react.useRef)(null);
    /**
       * to track previous value of range.
       * keys can have any value (just to maintain an entry).
       * this will help in reducing calls for `intersectionCallback`
       * check implementation of `handleRangeChanged`
       */ var rowChangeTrackerRef = (0,react.useRef)({});
    var isItemCardType = function(itemType) {
        return itemType === "product-card" || itemType === "product-card-skeleton";
    };
    /**
       * NOTE:- any operation on this page will now be done on slicedItems (unless there is a very specific need)
       * converting a list of items whose types are defined in `ItemTypes` to renderable format.
       *
       * ## representing items by type
       * eg. ["component", "product-card", "product-card","product-card","product-card","product-card","product-card"]
       * lets say `itemsRenderConfig.columnCount` = 3
       * [
       *    "component",
       *    "sliced-flex-cards": ["product-card", "product-card","product-card"],
       *    "sliced-flex-cards": ["product-card", "product-card","product-card"],
       * ]
       *
       * this function treats `product-card` and `product-card-skeleton` as similar objects.
       * to add/remove skeleton loaders, we need to add/remove them from listData
       */ var slicedItems = (0,react.useMemo)(function() {
        var resultantPageData = [];
        var indexedListData = listData === null || listData === void 0 ? void 0 : listData.map(function(item, idx) {
            // indexedListData will have an index key for every item so that the items can be tracked after shuffling in slicing phase
            item.index = idx;
            return item;
        });
        for(var index = 0; index < (indexedListData === null || indexedListData === void 0 ? void 0 : indexedListData.length); index++){
            // whenever a card is found, make sets of cards for rendering in a row
            if (isItemCardType(indexedListData[index].type)) {
                var cardRowsObj = generateCardRows(indexedListData, index);
                index = cardRowsObj.updatedIndex;
                resultantPageData = (0,_to_consumable_array/* default */.Z)(resultantPageData || []).concat((0,_to_consumable_array/* default */.Z)(cardRowsObj.cardRows || []));
            }
            resultantPageData.push(indexedListData[index]);
        }
        return resultantPageData;
    }, [
        listData
    ]);
    // extracting the `scrollToIndex` from Virtuoso component and exposing it to parent for the auto scroll functionality
    (0,react.useImperativeHandle)(virtualisedGridListReference, function() {
        return {
            scrollToIndex: handleScrollToIndex
        };
    });
    /**
       * since every row is either a `sliced-flex-cards` or a `component`,
       * we calculate the index where an element to scroll is lying after converting to sliced flex.
       */ var handleScrollToIndex = function(indexToScroll) {
        var _loop = function(index) {
            var item = slicedItems[index];
            if ((item === null || item === void 0 ? void 0 : item.type) === "sliced-flex-cards") {
                var ref;
                (ref = item === null || item === void 0 ? void 0 : item.data) === null || ref === void 0 ? void 0 : ref.forEach(function(sliceItem) {
                    if (sliceItem.index === indexToScroll) {
                        idexToScrollAfterSlicing = index;
                    }
                });
            } else {
                if (indexToScroll === (item === null || item === void 0 ? void 0 : item.index)) {
                    idexToScrollAfterSlicing = index;
                }
            }
        };
        var idexToScrollAfterSlicing = undefined;
        for(var index = 0; index <= (slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems.length); index++)_loop(index);
        if (idexToScrollAfterSlicing || idexToScrollAfterSlicing === 0) {
            var // offset to place scrolled item in center
            ref, ref1;
            virtuosoGridRef === null || virtuosoGridRef === void 0 ? void 0 : (ref = virtuosoGridRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollToIndex) === null || ref1 === void 0 ? void 0 : ref1.call(ref, {
                index: idexToScrollAfterSlicing,
                align: "center",
                offset: 200
            });
        }
    };
    var handleRangeChanged = function(range) {
        var previousRange = cloneDeep_default()(rowChangeTrackerRef.current);
        var newRange = {};
        var startIndex = range === null || range === void 0 ? void 0 : range.startIndex;
        var endIndex = range === null || range === void 0 ? void 0 : range.endIndex;
        for(var index = startIndex; index <= endIndex; index++){
            // track all indexes currently on screen
            newRange[index] = 1;
            // exclude intersection callback if index present in previous row change
            if (previousRange[index]) {
                continue;
            }
            var item = slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems[index];
            if (!item) {
                break;
            }
            if (item.type === "sliced-flex-cards") {
                var ref;
                (ref = item === null || item === void 0 ? void 0 : item.data) === null || ref === void 0 ? void 0 : ref.forEach(function(element) {
                    var ref;
                    element === null || element === void 0 ? void 0 : (ref = element.intersectionCallback) === null || ref === void 0 ? void 0 : ref.call(element);
                });
            } else {
                var ref1;
                item === null || item === void 0 ? void 0 : (ref1 = item.intersectionCallback) === null || ref1 === void 0 ? void 0 : ref1.call(item);
            }
        }
        rowChangeTrackerRef.current = newRange;
    };
    var renderItemContent = (0,react.useCallback)(function(index, listItem) {
        if ((listItem === null || listItem === void 0 ? void 0 : listItem.type) === "component") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(listItem.Component, {});
        } else if ((listItem === null || listItem === void 0 ? void 0 : listItem.type) === "sliced-flex-cards") {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    columnGap: itemsRenderConfig.columnGap,
                    margin: "".concat(itemsRenderConfig.rowGap, "px 0")
                },
                className: "tw-flex tw-flex-row tw-items-start tw-justify-start",
                children: listItem === null || listItem === void 0 ? void 0 : (ref = listItem.data) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
                    if ((item === null || item === void 0 ? void 0 : item.type) === "product-card") {
                        return renderProductCard(item === null || item === void 0 ? void 0 : item.index, item === null || item === void 0 ? void 0 : item.data);
                    } else if ((item === null || item === void 0 ? void 0 : item.type) === "product-card-skeleton") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSkeleton/* default */.Z, {}, idx);
                    }
                })
            });
        }
    }, [
        slicedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Virtuoso */.OO, {
        useWindowScroll: useWindowScroll,
        ref: virtuosoGridRef,
        rangeChanged: handleRangeChanged,
        increaseViewportBy: INCREASE_VIEWPORT_BY,
        data: slicedItems,
        defaultItemHeight: defaultItemHeight || 400,
        itemContent: renderItemContent,
        components: {
            Item: function(_param) {
                var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
                    "children"
                ]);
                var itemIndex = props === null || props === void 0 ? void 0 : props["data-index"];
                var correspondingItem = slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems[itemIndex];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    // Just to remove an error due zero element height in the internal working of virtuoso
                    style: {
                        minHeight: "1px"
                    },
                    children: children
                }), correspondingItem === null || correspondingItem === void 0 ? void 0 : correspondingItem.id);
            },
            // eslint-disable-next-line react/display-name
            List: /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
                var style = _param.style, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
                    "style",
                    "children"
                ]);
                return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref
                }, props), {
                    style: (0,_object_spread/* default */.Z)({}, style, virtualisationContainerStyle),
                    children: children
                }));
            })
        }
    });
}), VirtualisedList_utils/* compareListData */.T);
VirtualisedGridList.displayName = "VirtualisedGridList";
/* harmony default export */ var VirtualisedList = (VirtualisedGridList);

// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/ProductListWrapper.tsx

















var MobileDsAds = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7198), __webpack_require__.e(6778)]).then(__webpack_require__.bind(__webpack_require__, 77198)).then(function(mod) {
        return mod.MobileDsAds;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77198)
            ];
        }
    },
    ssr: false
});
var Card = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(258), __webpack_require__.e(3548)]).then(__webpack_require__.bind(__webpack_require__, 950258)).then(function(mod) {
        return mod.Card;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(950258)
            ];
        }
    }
});
var ProductCard = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(437), __webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(2287), __webpack_require__.e(4505), __webpack_require__.e(2755), __webpack_require__.e(2285)]).then(__webpack_require__.bind(__webpack_require__, 632755)).then(function(mod) {
        return mod.ProductCard;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(632755)
            ];
        }
    }
});
var AdvanceCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5195).then(__webpack_require__.bind(__webpack_require__, 185195)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(185195)
            ];
        }
    }
});
// Product list is put got like this to get category wise data etc.
// eslint-disable-next-line react/display-name
var ProductListWrapper = /*#__PURE__*/ (0,react.forwardRef)(function(param, productListWrapperReference) {
    var _children = param.children, children = _children === void 0 ? null : _children, tmp = param.productList, passedProductList = tmp === void 0 ? [] : tmp, _oldCardConfigs = param.oldCardConfigs, oldCardConfigs = _oldCardConfigs === void 0 ? {
        showButton: true,
        noTags: false,
        showCategoryCard: false,
        noTagsReadState: "fromProp",
        isWishlistCard: false,
        onWishlistDeleteClick: undefined
    } : _oldCardConfigs, _hideLoaderSkeleton = param.hideLoaderSkeleton, hideLoaderSkeleton = _hideLoaderSkeleton === void 0 ? false : _hideLoaderSkeleton, _skeletonCount = param.skeletonCount, skeletonCount = _skeletonCount === void 0 ? 3 : _skeletonCount, _overrideGlobalBuilderProductCard = param.overrideGlobalBuilderProductCard, overrideGlobalBuilderProductCard = _overrideGlobalBuilderProductCard === void 0 ? false : _overrideGlobalBuilderProductCard, _renderAdvancedCard = param.renderAdvancedCard, renderAdvancedCard = _renderAdvancedCard === void 0 ? false : _renderAdvancedCard, _CustomCardComponent = param.CustomCardComponent, CustomCardComponent = _CustomCardComponent === void 0 ? null : _CustomCardComponent, customClass = param.customClass, _calculateSelfDimensions = param.calculateSelfDimensions, calculateSelfDimensions = _calculateSelfDimensions === void 0 ? false : _calculateSelfDimensions, _renderType = param.renderType, renderType = _renderType === void 0 ? "grid" : _renderType;
    var ref;
    var ref1 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref1.widgetContextState, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var storeData = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref2 = (0,ProductListWrapper_utils/* useProductCardElements */.S3)(), layoutElement = ref2.layoutElement, infoList = ref2.infoList, isProductCardEnabled = ref2.isProductCardEnabled;
    var showCustomProductCard = isProductCardEnabled && (infoList === null || infoList === void 0 ? void 0 : infoList.length) && !overrideGlobalBuilderProductCard ? true : false;
    var layoutElementConfig = layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.config;
    var cardWrapperConfigs = (0,utils/* getCartWrapperConfigs */.Ui)(layoutElementConfig);
    var productItemContainerRef = (0,react.useRef)(null);
    var virtuosoGridRef = (0,react.useRef)(null);
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = (isBuilder ? previewDevice === "mobile" : false) || deviceType === "mobile";
    var ref3 = (0,react.useState)({
        containerWidth: 0
    }), listDimensions = ref3[0], setListDimensions = ref3[1];
    var productList = (0,react.useMemo)(function() {
        if (!Array.isArray(passedProductList) || !(passedProductList === null || passedProductList === void 0 ? void 0 : passedProductList.length)) return [];
        if (renderType === "virtualised-grid") return passedProductList;
        return passedProductList.filter(function(data) {
            var ref;
            return data.is_active === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE && (!(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock) || (data === null || data === void 0 ? void 0 : data.available));
        });
    }, [
        passedProductList,
        passedProductList === null || passedProductList === void 0 ? void 0 : passedProductList.length,
        storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock, 
    ]);
    var columnsMobile = (layoutElementConfig === null || layoutElementConfig === void 0 ? void 0 : layoutElementConfig.numColumnsMobile) || 2;
    var coumnsDesktop = (layoutElementConfig === null || layoutElementConfig === void 0 ? void 0 : layoutElementConfig.numColumnsDesktop) || 3;
    var gaps = (0,ProductListWrapper_utils/* calculateLayoutGap */.eH)({
        showCustomProductCard: showCustomProductCard,
        cardWrapperConfigs: cardWrapperConfigs,
        isMobile: isMobile
    });
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref4[0];
    var columnNum = isMobile ? columnsMobile : coumnsDesktop;
    var OldCardComponent = CustomCardComponent || (!renderAdvancedCard ? Card : AdvanceCard);
    var ref5 = (0,react.useState)({
        open: false,
        message: ""
    }), snackbarConfig = ref5[0], setSnackbarConfig = ref5[1];
    var showVirtualisedList = renderType === "virtualised-grid";
    // extracting the `scrollToIndex` from Virtuoso component and exposing it to parent for the auto scroll functionality
    (0,react.useImperativeHandle)(productListWrapperReference, function() {
        return {
            scrollToIndex: function(index) {
                var ref, ref1;
                return virtuosoGridRef === null || virtuosoGridRef === void 0 ? void 0 : (ref = virtuosoGridRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollToIndex) === null || ref1 === void 0 ? void 0 : ref1.call(ref, index);
            }
        };
    });
    (0,react.useEffect)(function() {
        var updateDimensions = function updateDimensions() {
            var ref;
            var sectionWidth = (ref = productItemContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
            if (sectionWidth) {
                setListDimensions(function(items) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, items), {
                        containerWidth: sectionWidth
                    });
                });
            }
        };
        var resObserver = new ResizeObserver(updateDimensions);
        productItemContainerRef.current && resObserver.observe(productItemContainerRef.current);
        updateDimensions();
        return function() {
            productItemContainerRef.current && resObserver.unobserve(productItemContainerRef.current);
        };
    }, []);
    // This is the padding that is added in the card when images is rendered in the card with padding
    // Horizontal Padding is added i.e. 10(leftPad) & 10(rightPad) = 20, will be removed from calculated
    // Image width will be minus these
    var cardWithMarginDimensions = cardWrapperConfigs.isCardLayout && !cardWrapperConfigs.isFullWidth ? isMobile ? 20 : 28 : 0;
    var imageWidth = function() {
        var totalGapWidth = (columnNum - (!isMobile ? 1 : 0)) * gaps.columnGap;
        var oneCardWidth = (listDimensions.containerWidth - totalGapWidth) / columnNum;
        // If not card with padding, then oneCardWidth is same as oneImageWidth
        var oneImgWidth = oneCardWidth - cardWithMarginDimensions;
        return oneImgWidth;
    }();
    var cardSelfDimensions = (0,ProductListWrapper_utils/* useProductCardDimensions */.lT)({
        imageWidth: imageWidth
    }).cardSelfDimensions;
    var cardWidth = cardSelfDimensions.cardWidth + cardWithMarginDimensions;
    // const canFitColumns = cardWidth * columnNum <= listDimensions.containerWidth;
    var canFitColumns = cardWidth - gaps.rowGap * columnNum <= listDimensions.containerWidth;
    var snackbarMethods = {
        openSnackbar: function(config) {
            return setSnackbarConfig((0,_object_spread/* default */.Z)({
                open: true
            }, config));
        },
        hideSnackbar: function() {
            return snackbarConfig.open && setSnackbarConfig(function(data) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    open: false
                });
            });
        }
    };
    var renderProductCard = (0,react.useCallback)(function(index, listItem) {
        var data = listItem;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                maxWidth: cardWidth,
                width: cardWidth
            },
            children: [
                showCustomProductCard && !(oldCardConfigs === null || oldCardConfigs === void 0 ? void 0 : oldCardConfigs.isWishlistCard) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                    productData: data,
                    itemIndex: index,
                    onItemClick: onItemClick,
                    configs: {
                        cardWrapperConfigs: cardWrapperConfigs,
                        isMobile: isMobile,
                        dimensions: cardSelfDimensions,
                        snackbarMethods: snackbarMethods
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OldCardComponent, (0,_object_spread/* default */.Z)({
                    data: data,
                    id: "".concat(data.name, "-").concat(data.id),
                    onItemClick: function() {
                        return onItemClick(data);
                    }
                }, oldCardConfigs)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDsAds, {
                    data: data
                })
            ]
        }, "items-card-" + data.id);
    }, [
        cardSelfDimensions
    ]);
    if (showVirtualisedList) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: productItemContainerRef,
            className: "tw-h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualisedList, {
                ref: virtuosoGridRef,
                useWindowScroll: !isBuilder,
                listData: productList,
                renderProductCard: renderProductCard,
                virtualisationContainerStyle: {},
                itemsRenderConfig: {
                    columnCount: canFitColumns ? columnNum : columnNum - 1,
                    columnGap: gaps.columnGap,
                    rowGap: gaps.rowGap
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        ref: productItemContainerRef,
        className: classnames_default()("newProductListingWrapper ", renderType === "grid" ? "tw-grid tw-justify-center tw-justify-items-center" : "no-scrollbar tw-flex tw-overflow-auto", customClass),
        style: {
            gridTemplateColumns: "repeat(".concat(canFitColumns ? columnNum : columnNum - 1, ", ").concat(isMobile ? cardWidth > 0 ? "minmax(10px, ".concat(cardWidth, "px)") : "1fr" : "minmax(10px, ".concat(showCustomProductCard || calculateSelfDimensions ? cardWidth : 220, "px)"), ")"),
            columnGap: "".concat(gaps.columnGap, "px"),
            rowGap: "".concat(gaps.rowGap, "px")
        },
        children: [
            (productList === null || productList === void 0 ? void 0 : productList.length) ? productList.map(function(data, index) {
                return renderProductCard(index, data);
            }) : !hideLoaderSkeleton && !!skeletonCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: new Array(skeletonCount).fill(0).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSkeleton/* default */.Z, {}, index);
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* CustomizedSnackbar */.y, {
                config: (0,_object_spread/* default */.Z)({}, snackbarConfig),
                handleSnackbarClose: function() {
                    return setSnackbarConfig(function(x) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                            open: false
                        });
                    });
                }
            })
        ]
    });
});


/***/ }),

/***/ 202386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S3": function() { return /* binding */ useProductCardElements; },
/* harmony export */   "eH": function() { return /* binding */ calculateLayoutGap; },
/* harmony export */   "lT": function() { return /* binding */ useProductCardDimensions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(474151);




var MAX_CARD_WIDTH = 450;
// const MIN_CARD_WIDTH = 200;
var MAX_CARD_HEIGHT = 450;
function useProductCardElements() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var ref3 = (globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.productCard) || {
        infoList: [],
        isEnabled: false
    }, infoList = ref3.infoList, isProductCardEnabled = ref3.isEnabled;
    var imageElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "image";
    });
    var layoutElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "layout";
    });
    return {
        isProductCardEnabled: isProductCardEnabled,
        layoutElement: layoutElement,
        imageElement: imageElement,
        infoList: infoList,
        aspectRatio: (imageElement === null || imageElement === void 0 ? void 0 : (ref = imageElement.config) === null || ref === void 0 ? void 0 : ref.aspectRatio) || (imageElement === null || imageElement === void 0 ? void 0 : (ref1 = imageElement.config) === null || ref1 === void 0 ? void 0 : ref1.aspectRation)
    };
}
function useProductCardDimensions(param) {
    var imageWidth = param.imageWidth;
    var aspectRatio = useProductCardElements().aspectRatio;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        cardHeight: 0,
        cardWidth: 0
    }), cardSelfDimensions = ref[0], setCardSelfDimensions = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (aspectRatio) {
            var aspectRatios = function() {
                var ratio = (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.split(":")) || [
                    1,
                    1
                ];
                return {
                    heightMultiplier: +ratio[1],
                    widthMultiplier: +ratio[0]
                };
            }();
            if (imageWidth) {
                var calculatedCardWidth = imageWidth > MAX_CARD_WIDTH ? MAX_CARD_WIDTH : //   ? MIN_CARD_WIDTH
                imageWidth;
                var calculatedCardHeight = calculatedCardWidth * (aspectRatios.heightMultiplier / aspectRatios.widthMultiplier);
                if (calculatedCardHeight > MAX_CARD_HEIGHT) {
                    calculatedCardHeight = MAX_CARD_HEIGHT;
                    calculatedCardWidth = calculatedCardHeight * (aspectRatios.widthMultiplier / aspectRatios.heightMultiplier);
                }
                setCardSelfDimensions(function(data) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                        cardWidth: calculatedCardWidth,
                        cardHeight: calculatedCardHeight
                    });
                });
            }
        }
    }, [
        imageWidth,
        aspectRatio
    ]);
    return {
        cardSelfDimensions: cardSelfDimensions
    };
}
var calculateLayoutGap = function(param) {
    var showCustomProductCard = param.showCustomProductCard, cardWrapperConfigs = param.cardWrapperConfigs, isMobile = param.isMobile;
    var gap = {
        columnGap: 20,
        rowGap: 30
    };
    if (!showCustomProductCard) return gap;
    if (!isMobile && !cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 28;
        gap.rowGap = 52;
        return gap;
    }
    if (!isMobile && cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 16;
        gap.rowGap = 16;
        return gap;
    }
    if (isMobile && !cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 16;
        gap.rowGap = 32;
        return gap;
    }
    gap.columnGap = 8;
    gap.rowGap = 8;
    return gap;
};


/***/ }),

/***/ 602641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ compareListData; },
/* harmony export */   "k": function() { return /* binding */ flattenCollectionCategoryItems; }
/* harmony export */ });
/**
   * function to convert nested collection category data to flattened format
   * eg.
   * ## original data
   * [
   *    collection: {
   *      category1: [item1, item2, item3],
   *      category2: [item1, item2, item3],
   *    },
   *    collection: {
   *      category1: [item1, item2, item3],
   *      category2: [item1, item2, item3],
   *    },
   * ]
   *
   * ## parsed data
   * note:- item can be a skeleton loader or a proper `FlattenRowDataType` object if loading is complete
   * [
   *  collection_heading, -> (as a component type item in the array)
   *  category_heading, -> (as a component type item in the array)
   *  item1,
   *  item2,
   *  collection_heading2, -> (as a component type item in the array)
   *  category_heading2, -> (as a component type item in the array)
   *  item1,
   *  item2,
   * ]
   */ function flattenCollectionCategoryItems(param) {
    var collections = param.collections, collectionCatalogItems = param.collectionCatalogItems, _skeletonCardsCount = param.skeletonCardsCount, skeletonCardsCount = _skeletonCardsCount === void 0 ? 3 : _skeletonCardsCount, collectionObject = param.collectionObject, categoryObject = param.categoryObject, itemObject = param.itemObject;
    var flattenData = [];
    collections.forEach(function(collection) {
        var ref;
        flattenData.push(collectionObject(collection));
        (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
            var ref, ref1;
            flattenData.push(categoryObject(collection, category));
            if ((collectionCatalogItems === null || collectionCatalogItems === void 0 ? void 0 : (ref = collectionCatalogItems[collection.id]) === null || ref === void 0 ? void 0 : (ref1 = ref[category.id]) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                var ref2, ref3;
                collectionCatalogItems === null || collectionCatalogItems === void 0 ? void 0 : (ref2 = collectionCatalogItems[collection.id]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[category.id]) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(productItem) {
                    return flattenData.push(itemObject(collection, category, productItem));
                });
            } else {
                Array(skeletonCardsCount).fill(0).map(function(_, index) {
                    flattenData.push({
                        id: "".concat(collection.id, "-").concat(category.id, "-").concat(index),
                        type: "product-card-skeleton"
                    });
                });
            }
        });
    });
    return flattenData;
}
var compareListData = function(prevProps, nextProps) {
    var ref, ref1, ref2;
    if (((ref = prevProps.listData) === null || ref === void 0 ? void 0 : ref.length) !== ((ref1 = nextProps.listData) === null || ref1 === void 0 ? void 0 : ref1.length)) return false;
    for(var i = 0; i < ((ref2 = prevProps.listData) === null || ref2 === void 0 ? void 0 : ref2.length); i++){
        var ref3, ref4;
        if (((ref3 = prevProps.listData[i]) === null || ref3 === void 0 ? void 0 : ref3.id) !== ((ref4 = nextProps.listData[i]) === null || ref4 === void 0 ? void 0 : ref4.id)) {
            return false;
        }
    }
    return true;
};


/***/ }),

/***/ 185810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CustomizedSnackbar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(414924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _mui_material_Snackbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(226379);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40416);
/* harmony import */ var _assets_svgExports_TickFill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72084);
/* harmony import */ var src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(662946);






// eslint-disable-next-line import/named

// eslint-disable-next-line import/named



function CustomizedSnackbar(param) {
    var config = param.config, _autoHideDuration = param.autoHideDuration, autoHideDuration = _autoHideDuration === void 0 ? 4500 : _autoHideDuration, handleSnackbarClose = param.handleSnackbarClose;
    var isMobile = (0,src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_3__/* .useGetDeviceType */ .n)().isMobile;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        open: false,
        message: "",
        vertical: "top",
        horizontal: "right",
        type: "success"
    }), 2), state = ref[0], setState = ref[1];
    var vertical = state.vertical, horizontal = state.horizontal;
    var open = config.open, message = config.message;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state, config));
    }, [
        config
    ]);
    var icon = function() {
        switch(state.type){
            case "success":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_TickFill__WEBPACK_IMPORTED_MODULE_2__/* .TickFill */ .v, {
                    width: 17,
                    height: 17,
                    color: "#32B272"
                });
            default:
                return null;
        }
    }();
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Snackbar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, horizontal === "center" && isMobile ? {
            left: "10% !important",
            right: "10% !important"
        } : {}), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"].root */ .Z.root), {
            minWidth: "auto",
            padding: "0px 0px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"].message */ .Z.message), {
            width: "100%",
            padding: "15px 20px",
            borderRadius: "6px",
            backgroundColor: "#111C36",
            boxShadow: "0px 4px 4px 0px #00000040"
        }), _obj)),
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        open: open,
        onClose: handleSnackbarClose,
        message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-justify-center tw-gap-[8px]",
            children: [
                icon,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " tw-m-0 tw-font-inter ",
                    children: message
                })
            ]
        })
    }, vertical + horizontal);
}


/***/ }),

/***/ 780058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useItemClick; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/utils/storeProductClickedDetails.js

function storeProductClickedDetails() {
    var expiresAt = new Date(new Date().getTime() + 30000);
    var sessionObject = {
        expiresAt: expiresAt,
        itemClickedData: {
            CLICKED_ITEM_X_OFFSET: scrollX,
            CLICKED_ITEM_Y_OFFSET: scrollY
        }
    };
    sessionStorage.setItem(constants/* CLICKED_ITEM_OBJ */.uI, JSON.stringify(sessionObject));
}

// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(813051);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(236913);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/isStoreB2B.js
var isStoreB2B = __webpack_require__(43935);
;// CONCATENATED MODULE: ./src/hooks/useItemClick.js










function useItemClick() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var getProductRoute = function(product) {
        var ref;
        var productUrl = product === null || product === void 0 ? void 0 : product.link;
        var productRoute = (0,routes.getRoute)((0,productUtils/* getProductPathFromUrl */.ts)(productUrl, false), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        return productRoute;
    };
    /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */ var onItemClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var e, openInNewTab, ref, getRoute, productRoute, paramStr, productRouteWithParam;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, openInNewTab = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        storeProductClickedDetails();
                        e && (e === null || e === void 0 ? void 0 : e.stopPropagation());
                        sessionStorage.setItem(constants/* CLICKED_ITEM_X_OFFSET */.AB, scrollX);
                        sessionStorage.setItem(constants/* CLICKED_ITEM_Y_OFFSET */.WR, scrollY);
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 540190)).then(function(module) {
                                return module.getRoute;
                            })
                        ];
                    case 1:
                        getRoute = _state.sent();
                        return [
                            4,
                            getProductRoute(item, getRoute)
                        ];
                    case 2:
                        productRoute = _state.sent();
                        /** if color is there push with color in query params */ if (item === null || item === void 0 ? void 0 : item.color) {
                            paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
                            productRouteWithParam = productRoute + paramStr;
                            window.location.href = productRouteWithParam;
                        } else if (!(0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) && !(0,isStoreB2B/* isB2BStore */.h)()) {
                            dispatch((0,catalog/* savePDPData */.zP)({
                                visible: true,
                                product: item
                            }));
                        } else {
                            openInNewTab ? window.open(productRoute, "_blank") : window.location.href = productRoute;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onItemClick(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var getLink = function(item, getRoute) {
        var ref;
        if (!item) {
            return;
        }
        var productRoute = getProductRoute(item, getRoute);
        var productLink = "";
        if (item === null || item === void 0 ? void 0 : item.color) {
            var paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
            productLink = productRoute + paramStr;
        } else if ((0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            productLink = productRoute;
        }
        return productLink || "";
    };
    return [
        onItemClick,
        getLink
    ];
}


/***/ }),

/***/ 813051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ canShowPDPSystem; }
/* harmony export */ });
var canShowPDPSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ })

}]);